import React from 'react';
import LazyLoad from 'react-lazyload';
import loadable from '@loadable/component';
import { FILTER_TYPES_STANDALONE, PRODUCT_VARIANT_ABBREVIATIONS } from '../../../shared/enums';
import { filterBillboardStatic } from '../../static-data';

const LazyImg = loadable(() => import('../common/LazyImg'));
const FadeIn = loadable(() => import('../common/FadeIn'));

/**
 * @param page
 * @returns {JSX.Element}
 * @constructor
 */
const FilterBillboard = ({ page }) => {
  const {
    type,
    text,
    titleImage,
    mediaImage,
    backgroundColor,
  } = filterBillboardStatic[page]
    || filterBillboardStatic[PRODUCT_VARIANT_ABBREVIATIONS.BASIC_BREATHER];

  return (
    <div className='filter-billboard filter-billboard--landscape-image filter-billboard-standalone' style={{ backgroundColor }}>
      <div className='filter-billboard__wrap'>
        <div className='filter-billboard__content'>
          <h2 className='filter-billboard__title mt-2'>
            <LazyImg src={titleImage} alt={type} />
            The
            {' '}
            {type}
          </h2>
          <p>
            {text}
          </p>
        </div>
        <figure className='filter-billboard__media'>
          <LazyLoad>
            <FadeIn>
              <img src={mediaImage} alt={`${FILTER_TYPES_STANDALONE[page]}-hero`} />
            </FadeIn>
          </LazyLoad>
        </figure>
      </div>
    </div>
  );
};

export default FilterBillboard;
